import { TOU_URL } from '@morpho-org/dapp-core'
import { DOCS_BASE_URL } from '@morpho-org/morpho-ts'

export const LANDING_URL = 'https://morpho.org'
export const CAREER_URL = 'https://morpho.org/jobs'
export const BLOG_URL = 'https://morpho.org/blog'

export const DOCUMENTATION_URL = DOCS_BASE_URL
export const API_DOCS_URL = DOCS_BASE_URL + '/developers/api/get-started/'
export const MCP_DOCS_URL = DOCS_BASE_URL + '/developers/agents/mcp/'
export const MORPHO_PRIVACY_URL = 'https://morpho.org/privacy-policy/'
export const MORPHO_TOU_URL = TOU_URL

export const X_URL = 'https://x.com/Morpho'
export const HELP_CENTER_URL = 'https://help.morpho.org/'
export const FORUM_URL = 'https://forum.morpho.org/'
export const REWARDS_URL = 'https://rewards.morpho.org/'
export const AUTO_DELEVERAGE_DOCS_URL =
  'https://help.morpho.org/en/articles/12048871-sunsetting-auto-deleverage'
export const FORCED_DEALLOCATION_HELP_URL =
  'https://help.morpho.org/en/articles/14779745-morpho-vaults-and-available-liquidity'
export const IN_KIND_REDEMPTION_HELP_URL =
  'https://help.morpho.org/en/articles/17241670-what-is-in-kind-redemption'
export const VAULTS_V2_DOCS_URL = DOCS_BASE_URL + '/learn/concepts/vault-v2/'
export const PUBLIC_ALLOCATOR_DOCS_URL = DOCS_BASE_URL + '/learn/concepts/public-allocator/'
export const SPARK_LIQUIDITY_LAYER_DOCS_URL =
  'https://docs.spark.finance/products/spark-liquidity-layer'

export const DATA_URL = 'https://data.morpho.org/'

// The Fixed Rate (Midnight) app — the sibling app we link out to (VRM-5344).
export const FIXED_RATE_APP_URL = 'https://markets.morpho.org'

export type FixedRateAppLinkMedium = 'topnav' | 'banner' | 'market_callout'

/**
 * Pre-filters the Fixed Rate market list. Its `/fixed` route matches these by
 * token **symbol**, case-sensitively and without normalization, so a rename on
 * their side silently drops the filter instead of erroring — keep in sync with
 * markets-app's token list.
 */
export interface FixedRateAppMarketFilter {
  loanSymbol: string
  collateralSymbol: string
}

// UTM params let the Fixed Rate app's PostHog attribute sessions to the main app
// (VRM-5344 / MKT-1501); auto-captured utm_* survive into the session there.
export const getFixedRateAppUrl = (
  medium: FixedRateAppLinkMedium,
  filter?: FixedRateAppMarketFilter
): string => {
  // The market list lives at /fixed; the params below do nothing on the root.
  const url = new URL(filter ? '/fixed' : '/', FIXED_RATE_APP_URL)
  if (filter) {
    url.searchParams.set('loan', filter.loanSymbol)
    url.searchParams.set('collateral', filter.collateralSymbol)
  }
  url.searchParams.set('utm_source', 'app.morpho.org')
  url.searchParams.set('utm_medium', medium)
  url.searchParams.set('utm_campaign', 'fixed-rate-cross-link')
  return url.toString()
}

export const ORACLE_METHODOLOGY_URL =
  'https://help.morpho.org/en/articles/12879577-oracles-on-morpho'
